import React, { Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import IconButton from '@material-ui/core/IconButton'
import DeleteIcon from '@material-ui/icons/Delete'
import Avatar from '../../../../common/Avatar'
import ListItemText from '../../../../common/ReversedListItemText'
import { ListItemSecondaryAction } from '@material-ui/core'
import ListingSearchBar from '../../../../common/ListingSearchBar'

const styles = theme => ({
  list: {
    padding: 0,
  },
  listHeader: {
    backgroundColor: theme.palette.grey[50],
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: '1px solid rgba(0,0,0,0.13)',
    borderTop: '1px solid rgba(0,0,0,0.13)',
  },
  listItem: {
    backgroundColor: 'rgba(255,255,255,0.1)',
    fill: theme.palette.common.white,
    '&:hover': {
      color: theme.palette.primary.main,
      fill: theme.palette.primary.main,
      backgroundColor: 'rgba(255,255,255,0.3)',
    },
  },
  listingAvatar: {
    height: 24,
    width: 24,
    border: '1px solid #d9d9d9',
    borderRadius: '50%',
  },
})

const BusinessListings = ({
  classes,
  business: { listings },
  listingSearchResults,
  searchListings,
  clearListings,
  handleListingSelect,
  handleListingDelete,
}) => {
  return (
    <Fragment>
      <DialogTitle id="responsive-dialog-title">Connected Listings</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Search for a listing to connect with your brand.
        </DialogContentText>
        <ListingSearchBar
          listings={listingSearchResults}
          onFetch={searchListings}
          onClear={clearListings}
          onSelect={handleListingSelect}
        />
        <List className={classes.list}>
          {listings && listings.length
            ? listings.sort().map(listing => (
                <ListItem key={listing.id} className={classes.listItem}>
                  <Avatar
                    className={classes.listingAvatar}
                    source={listing.logoUrl}
                  />
                  <ListItemText primary={listing.name} />
                  <ListItemSecondaryAction>
                    <IconButton>
                      <DeleteIcon onClick={handleListingDelete(listing)} />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              ))
            : null}
        </List>
      </DialogContent>
    </Fragment>
  )
}

export default withStyles(styles, { withTheme: true })(BusinessListings)



// WEBPACK FOOTER //
// ./src/components/account/businesses/CreateDialog/Steps/BusinessListings.js